// v2.18.5 — Toast embouteillage sticky top-center (sous la pill HUD).
// Affiché quand le watchdog détecte une vitesse < 5 km/h sur ≥ 60s et qu'OSRM
// propose une alternative ≥ 20% / 3 min plus rapide.

import { useEffect, useState } from "react";

export default function TrafficRerouteToast({ payload, onAccept, onReject, autoMode = false }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => { const t = setTimeout(() => setMounted(true), 20); return () => clearTimeout(t); }, []);

  if (!payload || !payload.best) return null;
  const { best } = payload;

  return (
    <div
      data-testid="traffic-reroute-toast"
      role="alertdialog"
      aria-live="assertive"
      style={{
        position: "fixed",
        top: 116, // sous la pill HUD (top:68 + 48px de marge)
        left: "50%",
        transform: `translateX(-50%) translateY(${mounted ? "0" : "-20px"})`,
        opacity: mounted ? 1 : 0,
        transition: "transform 300ms ease-out, opacity 300ms ease-out",
        zIndex: 60,
        width: "min(92vw, 360px)",
        background: "rgba(15, 23, 42, 0.94)",
        border: "1px solid rgba(239, 68, 68, 0.55)",
        borderRadius: 14,
        boxShadow: "0 18px 48px rgba(220, 38, 38, 0.25), 0 6px 18px rgba(0,0,0,0.55)",
        backdropFilter: "blur(14px)",
        color: "#F1F5F9",
        padding: "12px 14px",
        fontFamily: "Inter, system-ui, sans-serif",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
        <span aria-hidden="true" style={{ fontSize: 18 }}>🚦</span>
        <strong data-testid="traffic-toast-title" style={{ fontSize: 14, color: "#FCA5A5", letterSpacing: 0.2 }}>
          Embouteillage détecté
        </strong>
        {autoMode && (
          <span style={{ marginLeft: "auto", fontSize: 9, fontWeight: 700, color: "#FBBF24", background: "rgba(251,191,36,0.15)", border: "1px solid rgba(251,191,36,0.4)", padding: "2px 6px", borderRadius: 999, letterSpacing: 0.3 }}>
            🤖 AUTO
          </span>
        )}
      </div>
      <div data-testid="traffic-toast-savings" style={{ fontSize: 12, color: "#CBD5E1", marginBottom: 10, lineHeight: 1.4 }}>
        Raccourci dispo : <strong style={{ color: "#86EFAC" }}>−{best.saving_minutes} min</strong>{" "}
        (<span style={{ color: "#86EFAC" }}>{best.saving_pct}% plus rapide</span>)
        {best.reason && (
          <div style={{ fontSize: 10, color: "#94A3B8", marginTop: 4 }}>{best.reason}</div>
        )}
        {payload.avg_speed_kmh != null && (
          <div style={{ fontSize: 10, color: "#64748B", marginTop: 2 }}>Vitesse actuelle : {payload.avg_speed_kmh} km/h</div>
        )}
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <button
          type="button"
          data-testid="traffic-toast-accept"
          onClick={onAccept}
          style={{
            flex: 1,
            background: "linear-gradient(135deg, #16A34A, #22C55E)",
            color: "#0F172A",
            border: "none",
            padding: "9px 12px",
            borderRadius: 9,
            fontSize: 12, fontWeight: 800,
            cursor: "pointer",
            boxShadow: "0 6px 16px rgba(34,197,94,0.4)",
          }}
        >✓ Prendre le raccourci</button>
        <button
          type="button"
          data-testid="traffic-toast-reject"
          onClick={onReject}
          style={{
            background: "transparent",
            color: "#CBD5E1",
            border: "1px solid rgba(255,255,255,0.18)",
            padding: "9px 14px",
            borderRadius: 9,
            fontSize: 12, fontWeight: 600,
            cursor: "pointer",
          }}
        >Non, je continue</button>
      </div>
    </div>
  );
}
